import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import Modal from '../modal/modal.jsx';

const Question = ({
    question,
    config,
    currentQuestionNumber,
    setCurrentQuestionNumber,
    answerTotals,
    setAnswerTotals,
    setShowRestartModal,
}) => {
    const [showHint, setShowHint] = useState(false);
    const [showAnswerResult, setShowAnswerResult] = useState(false);
    const [answerCorrect, setAnswerCorrect] = useState(false);
    const [hintUsed, setHintUsed] = useState(false);

    const updatePlayData = (skipped, answer, correct, hint) => {
        const playData = JSON.parse(window.sessionStorage.getItem('playData'));
        const questionData = {};
        questionData.question = question.question_title;
        if (skipped) {
            questionData.skipped = true;
        } else {
            questionData.answer = answer;
            questionData.correct = correct;
            questionData.hint = hint;
        }
        playData.push(questionData);
        window.sessionStorage.setItem('playData', JSON.stringify(playData))
    };

    const checkAnswer = (answer) => {
        const answerNumber = parseInt(answer.getAttribute('data-number'));
        const correctAnswer = question.correct_answer;

        if (answerNumber === correctAnswer) {
            setAnswerCorrect(true);
            updatePlayData(false, answerNumber, true, hintUsed); // Correct answer

            let score = answerTotals;

            if (hintUsed) {
                score[question.category.toLowerCase()].score += 1; // half points if hint used
                score[question.category.toLowerCase()].hints += 1;
            } else {
                score[question.category.toLowerCase()].score += 2;
            }
            score[question.category.toLowerCase()].totalCorrect += 1;
            setAnswerTotals(score);
        } else {
            setAnswerCorrect(false);
            updatePlayData(false, answerNumber, false, hintUsed);
        }
        setShowAnswerResult(true);
    };

    const goToNextQuestion = (skipped) => {
        if (skipped) {
            updatePlayData(true);
        }
        setCurrentQuestionNumber(currentQuestionNumber + 1);
        setShowAnswerResult(false);
    };

    const displayHint = () => {
        setShowHint(true);
        setHintUsed(true);
    };

    const restartQuizFunc = () => {
        setShowRestartModal(true);
    };

    // make sure images are coming from outside the package
    let imagePath;

    if (config.configPath.includes('/')) {
        imagePath = config.configPath.split('/').slice(0, -1).join('/') + '/questions/puzzle-screen-questions/images/';
    } else if (config.configPath.includes('\\')) {
        imagePath = config.configPath.split('\\').slice(0, -1).join('\\') + '\\questions\\puzzle-screen-questions\\images\\';
    }

    return (
        <div className="question">

            <CSSTransition appear in={showHint} classNames="fade" timeout={300} unmountOnExit>
                <Modal text={question.hint_text} title={config.screens.puzzleScreen.hint_title} closeText={config.screens.puzzleScreen.hint_close} closeFunction={setShowHint} modalType="hint"/>
            </CSSTransition>

            {/* correct / incorrect modal */}
            <CSSTransition appear in={showAnswerResult && answerCorrect} classNames="fade" timeout={300} unmountOnExit>
                <Modal text={question.explanation} title={config.screens.puzzleScreen.correct_title} closeText={config.screens.puzzleScreen.next_question_text} closeFunction={goToNextQuestion} modalType="correct" />
            </CSSTransition>

            <CSSTransition appear in={showAnswerResult && !answerCorrect} classNames="fade" timeout={300} unmountOnExit>
                <Modal text={question.explanation} title={config.screens.puzzleScreen.incorrect_title} closeText={config.screens.puzzleScreen.next_question_text} closeFunction={goToNextQuestion} modalType="incorrect" />
            </CSSTransition>

            <img
                className="main-image"
                src={question.image_path ? imagePath + question.image_path : config.screens.puzzleScreen.default_main_image}
                alt=""
            />

            <div className="content">
                {/* question number and category */}
                <div className="question-header">
                    <span className="question-number">Question {currentQuestionNumber}/9</span>
                    <span className="question-category">{question.category}</span>
                </div>

                {/* question details - title and body */}
                <div className="question-details">
                    <h1 className="question-title">{question.question_title}</h1>
                    <p className={`question-text ${question.answer_type}-type`}>{question.question_text}</p>
                </div>

                {/* answer list */}
                <div className="answers">
                    <span className="answer-prompt">{config.screens.puzzleScreen.answer_prompt}</span>

                    <div className="answer-list">
                    {question.answers.map((answer, index) => {
                        return (
                            <div className="answer" key={index} onClick={(e) => {checkAnswer(e.currentTarget)}} data-number={index + 1} >
                                {question.answer_type === 'image' &&
                                    <img src={imagePath + answer.answer_content} alt="" className="answer-image" />
                                }
                                {question.answer_type === 'text' &&
                                    <span className="answer-text">{answer.answer_content}</span>
                                }
                                {question.answer_type === 'vertical-text' &&
                                    <span className="answer-text vertical-text">{answer.answer_content}</span>
                                }
                                <span className="shadow"> </span>
                            </div>
                        )
                    })}
                    </div>
                </div>

                {/* hint + skip buttons */}
                <div className="progression-bar">
                    <div className="buttons">
                        <button
                            className="buttons__restart"
                            onClick={restartQuizFunc}>
                            Restart
                        </button>
                        <button className="hint-button" onClick={() => displayHint()}>
                            {config.screens.puzzleScreen.hint_button}
                        </button>
                        <button className="skip-button" onClick={() => {
                            goToNextQuestion('skipped')
                        }}>
                            {config.screens.puzzleScreen.skip_button}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Question;
